import {
	IUserProfile,
	IUserProfileData,
	IUserProfileAction,
	ICookieTypes,
	IUserProfileApiResponse,
} from 'models/user/userprofile';
import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import { getUserPreferences } from 'modules/user/userpreferences';
import { closeModal } from 'redux/modules/modal';
import { browserHistory } from 'react-router';
import { Gender } from '../../../../models/enums/gender';
import { onboardingQuizSuccess } from 'redux/modules/onboardingquiz';
const { notifSend } = notifActions;

/** Action Types */
export const GET_REQUEST: string = 'userprofile/GET_REQUEST';
export const GET_SUCCESS: string = 'userprofile/GET_SUCCESS';
export const GET_FAILURE: string = 'userprofile/GET_FAILURE';
export const SET_COOKIES: string = 'userprofile/SET_COOKIES';

export const PUT_REQUEST: string = 'userprofile/PUT_REQUEST';
export const PUT_SUCCESS: string = 'userprofile/PUT_SUCCESS';
export const PUT_FAILURE: string = 'userprofile/PUT_FAILURE';

/** Initial State */
const initialState: IUserProfileData = {
	user: null,
	cookies: {
		hasAcceptedCookies: false,
		types: {
			necesarry: true,
			analytics: true,
			marketing: true,
		},
	},
	isFetching: false,
};

/** Reducer */
export function userProfileReducer(state = initialState, action: IUserProfileAction) {
	switch (action.type) {
		case GET_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				user: action.payload.user,
			});

		case GET_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_COOKIES:
			return Object.assign({}, state, {
				cookies: {
					hasAcceptedCookies: true,
					types: {
						necesarry: action.payload.cookieTypes.necesarry,
						analytics: action.payload.cookieTypes.analytics,
						marketing: action.payload.cookieTypes.marketing,
					},
				},
			});

		case PUT_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case PUT_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				user: action.payload.user,
			});

		case PUT_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function getUserProfile() {
	return (dispatch, getState: () => IStore): Promise<any> => {
		dispatch(userProfileRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userprofile',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IUserProfileApiResponse) => {
						const splitNumbers: IUserProfile = {
							...res,
							hairProducts: (res.hairProducts || '').split(',').filter(Boolean).map(Number),
							brands: (res.brands || '').split(',').filter(Boolean).map(Number),
							goals: (res.goals || '').split(',').filter(Boolean).map(Number),
							skinProblems: (res.skinProblems || '').split(',').filter(Boolean).map(Number),
						};
						dispatch(userProfileSuccess(splitNumbers));
						dispatch(onboardingQuizSuccess(splitNumbers));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userProfileFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userProfileFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userProfileFailure(err));
			});
	};
}

/** Async Action Creator */
export function deactivateAccount(redirectUrl: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(userProfileRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userprofile/Deactivate',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(closeModal());
					browserHistory.push(redirectUrl);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userProfileFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userProfileFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userProfileFailure(err));
			});
	};
}

/** Action Creator */
export function acceptCookies(cookieTypes: ICookieTypes): IUserProfileAction {
	return {
		type: SET_COOKIES,
		payload: {
			cookieTypes,
		},
	};
}

/** Action Creator */
export function userProfileRequest(): IUserProfileAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function userProfileSuccess(user: IUserProfile): IUserProfileAction {
	// TODO: HACK -> return enums as strings!
	if (user.gender === null) {
		user.gender = Gender.Unspecified.toString();
	} else {
		user.gender = user.gender.toString();
	}

	return {
		type: GET_SUCCESS,
		payload: {
			user,
		},
	};
}

/** Action Creator */
export function userProfileFailure(message: any): IUserProfileAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}
/** Action Creator - update */
export function putUserProfile(user: IUserProfile) {
	return (dispatch, getState: () => IStore) => {
		dispatch(userProfilePutRequest());

		if (user.socialLinksObj) {
			user.socialLinks = JSON.stringify(user.socialLinksObj);
		}

		if (user.gender === Gender.Unspecified.toString()) {
			user.gender = null;
		}

		const userToUpdate: IUserProfileApiResponse & { gender?: any } = {
			...user,
			hairProducts: user.hairProducts.join(',') || null,
			brands: user.brands.join(',') || null,
			goals: user.goals.join(',') || null,
			skinProblems: user.skinProblems.join(',') || null,
		};
		if (userToUpdate.gender !== null) {
			userToUpdate.gender = parseInt(userToUpdate.gender, 10);
		}
		if (userToUpdate.coloredHair === '0') {
			userToUpdate.coloredHair = false as any;
		} else if (userToUpdate.coloredHair === '1') {
			userToUpdate.coloredHair = true as any;
		} else {
			userToUpdate.coloredHair = undefined;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userprofile',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(userToUpdate),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(userProfilePutSuccess(user));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_User_Profile_Updated'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
					dispatch(getUserPreferences());
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userProfilePutFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userProfilePutFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userProfilePutFailure(err));
			});
	};
}

export function deactivateUser() {
	return (dispatch, getState: () => IStore) => {
		dispatch(userProfilePutRequest());

		const returnUrl = '?returnUrl=' + getState().fetchDefault.baseUrlClient;
		return fetch(
			getState().fetchDefault.baseAPI + 'api/userprofile/deactivate' + returnUrl,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(closeModal());
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_User_Profile_Deactivated'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userProfilePutFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userProfilePutFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userProfilePutFailure(err));
			});
	};
}

/** Action Creator */
export function userProfilePutRequest(): IUserProfileAction {
	return {
		type: PUT_REQUEST,
	};
}

/** Action Creator */
export function userProfilePutSuccess(user: IUserProfile): IUserProfileAction {
	if (user.gender === null) {
		user.gender = Gender.Unspecified.toString();
	}

	return {
		type: PUT_SUCCESS,
		payload: {
			message: 'OK',
			user,
		},
	};
}

export function userProfilePutFailure(message: any): IUserProfileAction {
	return {
		type: PUT_FAILURE,
		payload: {
			message,
		},
	};
}
